import React from 'react';

import SelectItem from './SelectItem/SelectItem';
import MustItem from '../MustItem/MustItem';
import OptionalItem from '../OptionalItem/OptionalItem';
import DotLine from '../DotLine';

const Selecter = props => {
    const activeIndex = props.selected;
    const { tab } = props;

    const setActive = num => {
      if (props.disable) { return null };
      props.onClick && props.onClick(num)
    };

    const mustItem = props.must ? <div className="MustItemWrapper" ><MustItem /></div> : <div className="MustItemWrapper" ><OptionalItem /></div>;
    const item = props.itemfalse ? null : mustItem;

    const underDot = props.underDot ? <DotLine className={`UnderDot${tab ? ' tab' : '' }`} /> : null;

    const title = props.title ? (
      <div className={`SelectorTitle${tab ? ' tab' : '' }`} >
        <div className="SelectorTitleText" >
          {props.title}
        </div>
      </div>
    ): null;

    return (
      <React.Fragment>
        <div className="Selector" style={{ ...props.style }} >
          {title}
          <div className={`SelectorItemArea${tab ? ' tab' : '' }`} >
            <div className={`SelectorItem${tab ? ' tab' : '' }`} >
              {item}
              {props.options.map((title, index) => (
                <SelectItem
                  key={index}
                  title={title}
                  active={activeIndex.indexOf(index) !== -1}
                  onClick={() => { setActive(index) }}
                  itemWidth={props.itemWidth}
                  tab={props.tab}
                  charactor={index===props.charactor}
                  disable={props.disable}
                />
              ))}
            </div>
          </div>
        </div>
        {underDot}
      </React.Fragment>
    );
  };

export default Selecter;
